<style src="css/testList.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="测试"></topbar>
        <div class="testBox">
            <div class="testItem" v-for="item in scaleInfoList" @click="to(`testDetail?scaleId=${item.scaleId}`)">
                <div class="leftBox">
                    <div class="picBox" :style="{background: `url(${EnvUrl}${item.pic}) no-repeat center/cover`}">
                        <div class="label">{{item.labelName}}</div>
                    </div>
                    <div class="mainBox">
                        <div class="testTitle">{{item.title}}</div>
                        <div class="titleContent">{{item.tagline}}</div>
                        <div class="numBox">{{item.testCount}}人已测
                            <div class="rightBox">立即开始</div>
                        </div>
                    </div>
                </div>

            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex:1,
                pageSize:10,
                noMoreData:false,
                scaleInfoList:[]
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

            to(n) {
                this.$router.push(`/${n}`)
            },
            async getScaleInfoList() {
                let obj={}
                obj.pageIndex=this.pageIndex;
                obj.pageSize=this.pageSize;
                obj.labelId=this.$route.query.labelId;
                obj.companyId=localStorage.getItem('companyId')?localStorage.getItem('companyId'):'';
                let data = await getSources("/bear-scale/api/scaleHomePage/getScaleInfoList.json",obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count=data.count;
                    this.scaleInfoList = [...this.scaleInfoList, ...data.scaleInfoList];
                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        console.log('显示')
                        this.noMoreData = true
                    } else {
                        console.log(2)
                        this.noMoreData = false
                    }
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getScaleInfoList()
                    }
                }
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getScaleInfoList();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/testList.vue?433dc5e0